// Mutation hook - upload zalacznika do transakcji (base64)
// POST /api/ui/sales-crm/deals/{id}/attachments

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostDealAttachmentRequest } from 'api/types/deals';

interface IPostDealAttachmentResponse {
  data?: { id?: number; dealId?: number };
  message?: string;
  status?: string;
}

interface IPostDealAttachmentVariables {
  dealId: number;
  body: IPostDealAttachmentRequest;
}

const postDealAttachment = ({ dealId, body }: IPostDealAttachmentVariables): Promise<IPostDealAttachmentResponse> =>
  axios.post(`/sales-crm/deals/${dealId}/attachments`, body);

export const usePostDealAttachment = (
  options?: UseMutationOptions<IPostDealAttachmentResponse, IError, IPostDealAttachmentVariables>,
) => {
  const queryClient = useQueryClient();
  // UWAGA: spread `...options` MUSI byc PRZED naszym `onSuccess`, inaczej options.onSuccess
  // z komponentu nadpisuje nasze invalidateQueries (kolejnosc kluczy w obiekcie). Lista
  // klucz queryKey rowniez: `await invalidate + refetch` aby UI dostal swieze dane
  // (samo invalidate nie wymusza refetch dla zapytan currently unmounted/stale).
  return useMutation<IPostDealAttachmentResponse, IError, IPostDealAttachmentVariables>(postDealAttachment, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deal-attachments', variables.dealId]);
      await queryClient.refetchQueries(['sales-crm-deal-attachments', variables.dealId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
